import { videoModel } from "./defaults";

export const klingO3 = videoModel("kling-o3", "Kling O3", { start: 1, end: 1 }, {
  firstLast: "kling-video/o3/first-last-frame",
});
